import React from 'react'

import {
  Box,
  Button,
  CollapsableCard,
  Text,
  useToggle,
} from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface CustomCardProps {
  title: string
  content: React.ReactNode
}

const CustomCard = ({ title, content }: CustomCardProps) => {
  const [open, setOpen] = useToggle(false)
  return (
    <Box>
      <CollapsableCard
        open={open}
        Card={
          <Box flexDirection="row" justifyContent="spaceBetween" gap="s16" alignItems="center">
            <Text.Normal weight="semibold">{title}</Text.Normal>
            <Button
              onClick={setOpen(!open)}
              type="secondary"
              iconName={`${open ? 'chevron-up' : 'chevron-down'}`}
            />
          </Box>
        }
        Content={content}
      />
    </Box>
  )
}

const FaqBlock = () => {
  const cardsContentFirstColumn = [
    {
      title: i18n.t('software_management.initial_setup.faq_block.cards.software.title'),
      content: (
        <Text.Normal>
          {i18n.t('software_management.initial_setup.faq_block.cards.software.content')}
        </Text.Normal>
      ),
    },
    {
      title: i18n.t('software_management.initial_setup.faq_block.cards.currency.title'),
      content: (
        <Text.Normal>
          {i18n.t('software_management.initial_setup.faq_block.cards.currency.content')}
        </Text.Normal>
      ),
    },
    {
      title: i18n.t('software_management.initial_setup.faq_block.cards.custom.title'),
      content: (
        <Text.Normal>
          {i18n.t('software_management.initial_setup.faq_block.cards.custom.content')}
        </Text.Normal>
      ),
    },
  ]

  const cardsContentSecondColumn = [
    {
      title: i18n.t('software_management.initial_setup.faq_block.cards.cards.title'),
      content: (
        <Text.Normal>
          {i18n.t('software_management.initial_setup.faq_block.cards.cards.content')}
        </Text.Normal>
      ),
    },
    {
      title: i18n.t('software_management.initial_setup.faq_block.cards.approvals.title'),
      content: (
        <Text.Normal>
          {i18n.t('software_management.initial_setup.faq_block.cards.approvals.content')}
        </Text.Normal>
      ),
    },
    {
      title: i18n.t('software_management.initial_setup.faq_block.cards.admin.title'),
      content: (
        <Text.Normal>
          {i18n.t('software_management.initial_setup.faq_block.cards.admin.content')}
        </Text.Normal>
      ),
    },
  ]

  return (
    <Box width="full" alignItems="center" padding="s64" gap="s48">
      <Box gap="s8" maxWidth="s400" textAlign="center">
        <Text weight="semibold" size="500" color="grey1000">
          {i18n.t('software_management.initial_setup.faq_block.title')}
        </Text>
        <Text.Normal weight="medium">
          {i18n.t('software_management.initial_setup.faq_block.description')}
        </Text.Normal>
      </Box>

      <Box flexDirection="row" width="full" gap="s12">
        <Box gap="s12" width="full">
          {cardsContentFirstColumn.map((item) => {
            return <CustomCard key={item.title} {...item} />
          })}
        </Box>
        <Box gap="s12" width="full">
          {cardsContentSecondColumn.map((item) => {
            return <CustomCard key={item.title} {...item} />
          })}
        </Box>
      </Box>
    </Box>
  )
}

export default FaqBlock
